const localizations = [
  {
    currency: "SEK",
    locale: "sv-SE", // Sweden
    countryCode: "SE",
  },
  {
    currency: "USD",
    locale: "en-US", // United States
    countryCode: "US",
  },
  {
    currency: "EUR",
    locale: "de-DE", // Germany
    countryCode: "DE",
  },
  {
    currency: "EUR",
    locale: "fi-FI", // Finland
    countryCode: "FI",
  },
  {
    currency: "EUR",
    locale: "de-DE", // Germany
    countryCode: "DE",
  },
];

export const formatMoney = (amount, currencyCode) => {
  // Find the localization for the given currencyCode
  const localization = localizations.find(
    (loc) => loc.currency === currencyCode
  );

  // If no localization found, fallback to 'sv-SE'
  const locale = localization ? localization.locale : "sv-SE";

  const decimalLength = 0;

  const options = {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: decimalLength,
    maximumFractionDigits: decimalLength,
  };

  // Use the `Intl.NumberFormat` API to format the amount
  const formatter = new Intl.NumberFormat(locale, options); // Adjust the locale as needed
  return formatter.format(amount); // This formats the amount with the currency symbol
};

export const formatTimeUnit = (timeUnit) => {
  switch (timeUnit) {
    case "monthly":
      return "Mån";
    case "weekly":
      return "Vecka";
    case "daily":
      return "Dag";
    case "hourly":
      return "Timme";
    default:
      return "Mån";
  }
};
